import {CounterLabel} from '@primer/react'
import {Count} from '@github-ui/count'
import {CollapsibleNavList} from '@github-ui/layout-primitives/CollapsibleNavList'

import type {AIResourceSearchCategory} from './types'

export function SearchCategoryNav({categories}: {categories: readonly AIResourceSearchCategory[]}) {
  return (
    <CollapsibleNavList aria-label="Search categories">
      {categories.map(category => (
        <CollapsibleNavList.LinkItem
          key={`${category.label}-${category.href}`}
          to={category.href}
          label={category.label}
          icon={category.icon}
          aria-current={category.current ? 'page' : undefined}
          trailingVisual={
            category.count === undefined ? undefined : (
              <CounterLabel>
                <Count value={category.count} />
              </CounterLabel>
            )
          }
          forceHardNavigation
        />
      ))}
    </CollapsibleNavList>
  )
}
